import { useState, useEffect } from 'react';

const DEFAULT_MESSAGES = [
  'Crunching some numbers...',
  'Sending the AI a request...',
  'Injecting AI power into your topic...',
  'Analyzing keyword patterns...',
  'Consulting the algorithm experts...',
  'Mining semantic gold...',
  'Teaching robots about your niche...',
  'Connecting neural pathways...',
  'Discovering hidden gems...',
  'Making the magic happen...',
];

interface LoadingSpinnerProps {
  messages?: string[];
  intervalMs?: number;
}

export default function LoadingSpinner({
  messages = DEFAULT_MESSAGES,
  intervalMs = 3000,
}: LoadingSpinnerProps) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [messages.length, intervalMs]);

  return (
    <div className="h-full flex flex-col items-center justify-center p-8">
      {/* Spinner */}
      <div className="relative mb-6">
        <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 rounded-full"></div>
        <div className="absolute top-0 left-0 w-16 h-16 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
        {/* Inner sparkle icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-blue-500 animate-pulse"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z" />
          </svg>
        </div>
      </div>

      {/* Rotating message */}
      <p className="text-gray-600 dark:text-gray-300 text-center transition-opacity duration-300">
        {messages[messageIndex]}
      </p>
    </div>
  );
}
